import { useState } from "react";
import { Send, MessageCircle } from "lucide-react";
import { waLink } from "../lib/business";

const initial = { name: "", phone: "", car: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(initial);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    const msg = [
      "السلام عليكم، أود تشخيص مشكلة في السيارة",
      "",
      `الاسم: ${form.name || "-"}`,
      `رقم الجوال: ${form.phone || "-"}`,
      `نوع السيارة: ${form.car || "-"}`,
      `وصف المشكلة: ${form.message || "-"}`,
    ].join("\n");
    window.open(waLink(msg), "_blank", "noopener,noreferrer");
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="contact-form"
      className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 lg:p-8"
    >
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-400 font-semibold mb-3">
        <span className="w-8 h-px bg-cyan-400" />
        اطلب تشخيص المشكلة
      </div>
      <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
        اشرح مشكلتك باختصار — ونرجع لك عبر واتساب
      </h3>
      <p className="mt-2 text-sm text-slate-400">
        كلما كانت التفاصيل أدق، كان التشخيص المبدئي أسرع.
      </p>

      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <label className="block">
          <span className="text-xs text-slate-400 mb-1.5 block">الاسم</span>
          <input
            type="text"
            name="name"
            required
            value={form.name}
            onChange={onChange}
            placeholder="اسمك الكريم"
            data-testid="contact-form-name"
            className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all"
          />
        </label>

        <label className="block">
          <span className="text-xs text-slate-400 mb-1.5 block">
            رقم الجوال
          </span>
          <input
            type="tel"
            name="phone"
            required
            value={form.phone}
            onChange={onChange}
            inputMode="tel"
            placeholder="05xxxxxxxx"
            data-testid="contact-form-phone"
            className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all tabular-nums"
          />
        </label>

        <label className="block sm:col-span-2">
          <span className="text-xs text-slate-400 mb-1.5 block">
            نوع السيارة
          </span>
          <input
            type="text"
            name="car"
            required
            value={form.car}
            onChange={onChange}
            placeholder="مثال: تويوتا كامري 2019"
            data-testid="contact-form-car"
            className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all"
          />
        </label>

        <label className="block sm:col-span-2">
          <span className="text-xs text-slate-400 mb-1.5 block">
            وصف المشكلة
          </span>
          <textarea
            name="message"
            required
            rows={5}
            value={form.message}
            onChange={onChange}
            placeholder="مثال: المكيف تبريده ضعيف من فترة، ويطلع صوت خفيف وقت التشغيل..."
            data-testid="contact-form-message"
            className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all resize-none"
          />
        </label>
      </div>

      <button
        type="submit"
        data-testid="contact-form-submit"
        className="mt-6 w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-xl bg-[#25D366] hover:bg-[#1DA851] text-white font-semibold transition-all shadow-[0_8px_30px_rgba(37,211,102,0.3)] hover:-translate-y-0.5"
      >
        <Send className="w-4 h-4" />
        إرسال الطلب عبر واتساب
        <MessageCircle className="w-4 h-4" />
      </button>
      <p className="mt-3 text-xs text-slate-500">
        سيتم فتح واتساب تلقائيًا مع رسالة جاهزة تحتوي على بياناتك.
      </p>
    </form>
  );
};

export default ContactForm;
